interface Args {
  firstName?: string;
  lastName?: string;
}

export const getUserName = (args: Args): string => {
  return [args.firstName, args.lastName].join(" ").trim();
};
